import { Link } from "react-router-dom";

const columns = [
  {
    title: "逛社区",
    links: [
      { label: "首页热搜榜", to: "/" },
      { label: "讨论区聚合", to: "/topics" },
      { label: "每日精选", to: "/topics" },
      { label: "常见问题", to: "/faq" },
    ],
  },
  {
    title: "热门板块",
    links: [
      { label: "校园热点", to: "/topics?category=campus" },
      { label: "宿舍日常", to: "/topics?category=dorm" },
      { label: "情感八卦", to: "/topics?category=love" },
      { label: "求职实习", to: "/topics?category=career" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容原则", to: "/about#principles" },
      { label: "用户口碑", to: "/about#voice" },
      { label: "联系我们", to: "/about#contact" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-primary-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-mic-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-black text-background-50">高校吃瓜网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-200">
              把各高校的热门讨论集中到一个地方，让你快速找到同校吃瓜现场，一网打尽学生都在聊什么。内容以用户分享为主，欢迎一起来维护讨论秩序。
            </p>
            <p className="mt-5 flex items-center gap-2 text-sm text-secondary-300">
              <span className="flex h-5 w-5 items-center justify-center">
                <i className="ri-mail-line"></i>
              </span>
              contact@gaoxiaochigua.cn
            </p>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
                {col.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.to}
                      className="text-sm text-primary-200 transition-colors hover:text-secondary-300"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 高校吃瓜网 · 校园话题聚合与讨论社区</p>
          <p className="flex flex-wrap items-center gap-4">
            <span>理性吃瓜，尊重每一位当事人</span>
            <Link to="/about#principles" className="transition-colors hover:text-secondary-300">
              社区内容原则
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}